import React, { useState } from "react";
import { View, Text, TouchableOpacity, ScrollView, StyleSheet, TextInput } from "react-native";
import { observer } from "mobx-react";
import { desenvolverStore } from "../stores/DesenvolverStore";
import { navigate } from "../services/NavigationService";
import { PencilSimpleIcon, TrashIcon, PlusIcon, FunnelSimple as FilterIcon, MagnifyingGlass as SearchIcon } from "@phosphor-icons/react";
import { Theme } from "../enum/Theme";
import { EnumRoutesAppWeb } from "../enum/EnumRoutesAppWeb";
import { Language } from "@constants/language";
import { ModalFiltroLanguage } from "../comps/ModalFiltroLanguage";
import SpaceW from "@comps/SpaceW";
import { getFlagByLanguage } from "../services/getFlagByLanguage";
import { ageRangeList } from "@enum/AgeRangeList";

const Desenvolver = observer(() => {
  const { ranges, loading, deleteRange } = desenvolverStore;

  const [modalVisible, setModalVisible] = useState(false);
  const [filterLang, setFilterLang] = useState<Language | null>(null);
  const [searchText, setSearchText] = useState("");

  const rangesFiltered = ranges.filter((range) => {
    // Filtro por idioma
    const matchesLanguage = !filterLang || range.lang === filterLang;
    
    // Filtro por busca (faixa etária, título, resumo e descrição da intro)
    const ageRangeLabel = ageRangeList.find((r) => r.value === range.id)?.label || "";
    const matchesSearch = !searchText || 
      ageRangeLabel.toLowerCase().includes(searchText.toLowerCase()) ||
      (range.intro?.title && range.intro.title.toLowerCase().includes(searchText.toLowerCase())) ||
      (range.intro?.resume && range.intro.resume.toLowerCase().includes(searchText.toLowerCase())) ||
      (range.intro?.description && range.intro.description.toLowerCase().includes(searchText.toLowerCase()));
    
    return matchesLanguage && matchesSearch;
  });

  if (loading) {
    return <Text style={{ textAlign: "center", marginTop: 50 }}>Carregando...</Text>;
  }

  return (
    <View style={styles.container}>
      <View style={styles.topBar}>
      {/*   <TouchableOpacity style={styles.addButton} onPress={() => navigate(EnumRoutesAppWeb.createEditDesenvolvimento)}>
          <PlusIcon size={20} color="#fff" />
          <Text style={styles.addButtonText}>Novo Desenvolvimento</Text>
        </TouchableOpacity> */}
        <TouchableOpacity style={styles.filterButton} onPress={() => setModalVisible(true)}>
          <FilterIcon size={22} color={Theme.foreground} />
        </TouchableOpacity>
      </View>

      <View style={styles.searchContainer}>
        <View style={styles.searchInputContainer}>
          <SearchIcon size={20} color="#666" style={styles.searchIcon} />
          <TextInput
            style={styles.searchInput}
            placeholder="Buscar por faixa etária ou conteúdo..."
            value={searchText}
            onChangeText={setSearchText}
            placeholderTextColor="#999"
          />
        </View>
      </View>

      <ScrollView>
        {rangesFiltered.map((range, index) => (
          <View style={styles.row} key={index.toString()}>
            <View>
              <Text style={{ fontSize: 18 }}>{getFlagByLanguage(range.lang)}</Text>
            </View>
            <SpaceW />
            <Text numberOfLines={1} ellipsizeMode="tail" style={styles.rowText}>
              {ageRangeList.find((r) => r.value === range.id)?.label || "-"} - {range?.intro?.title || "-"}
            </Text>
            <SpaceW />
            <View style={styles.actions}>
              <TouchableOpacity onPress={() => navigate(EnumRoutesAppWeb.createEditDesenvolvimento, { range })}>
                <PencilSimpleIcon size={20} color="#555" />
              </TouchableOpacity>
              <SpaceW />
              <TouchableOpacity onPress={() => deleteRange(range.id, range.lang)}>
                <TrashIcon size={20} color="#E57373" />
              </TouchableOpacity>
            </View>
          </View>
        ))}
      </ScrollView>

      <ModalFiltroLanguage
        visible={modalVisible}
        value={filterLang}
        onSelect={setFilterLang}
        onClose={() => setModalVisible(false)}
      />
    </View>
  );
});

export default Desenvolver;

const styles = StyleSheet.create({
  container: { flex: 1, padding: 20, backgroundColor: "#F2F2F2" },
  topBar: { flexDirection: "row", alignItems: "center", marginBottom: 15 },
  addButton: { backgroundColor: Theme.foreground, padding: 10, borderRadius: 5, flexDirection: "row", alignItems: "center" },
  addButtonText: { color: "#fff", marginLeft: 5 },
  filterButton: { marginLeft: 10, padding: 7, borderRadius: 5, backgroundColor: "#e6e6e6" },
  searchContainer: { marginBottom: 15 },
  searchInputContainer: { 
    flexDirection: "row", 
    alignItems: "center", 
    backgroundColor: "#fff", 
    borderRadius: 8, 
    paddingHorizontal: 12, 
    paddingVertical: 8,
    borderWidth: 1,
    borderColor: "#ddd"
  },
  searchIcon: { marginRight: 8 },
  searchInput: { 
    flex: 1, 
    fontSize: 16, 
    color: "#333",
    paddingVertical: 4
  },
  row: { flexDirection: "row", justifyContent: "space-between", alignItems: "center", paddingVertical: 10, borderBottomWidth: 1, borderBottomColor: "#ccc" },
  rowText: { flex: 2 },
  actions: { flexDirection: "row", gap: 10 },
});
